var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button primary",on:{"click":function($event){$event.preventDefault();return _vm.onClickTest($event)}}},[_vm._v("TEST")])}
var staticRenderFns = []

export { render, staticRenderFns }